import { render } from "./CarCard.vue?vue&type=template&id=33b66920&scoped=true"
import script from "./CarCard.vue?vue&type=script&lang=js"
export * from "./CarCard.vue?vue&type=script&lang=js"

import "./CarCard.vue?vue&type=style&index=0&id=33b66920&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-33b66920"]])

export default __exports__